module.exports = __webpack_public_path__ + "static/media/Untitled-1.a63510d4.png";